export const TeamTypes = {
  SmallBusiness: 'small business',
  Marketing: 'marketing',
  Education: 'education',
  EngineeringIT: 'engineering-it',
  SalesCRM: 'sales crm',
  Operations: 'operations',
  HumanResources: 'human resources',
  Other: 'other',
} as const;
export type TeamType = (typeof TeamTypes)[keyof typeof TeamTypes];
